import moment from "moment";

export const changeOnlyMonthSlip = (date) => {
  let monthThai = [];
  monthThai["01"] = "มกราคม";
  monthThai["02"] = "กุมภาพันธ์";
  monthThai["03"] = "มีนาคม";
  monthThai["04"] = "เมษายน";
  monthThai["05"] = "พฤษภาคม";
  monthThai["06"] = "มิถุนายน";
  monthThai["07"] = "กรกฎาคม";
  monthThai["08"] = "สิงหาคม";
  monthThai["09"] = "กันยายน";
  monthThai["10"] = "ตุลาคม";
  monthThai["11"] = "พฤศจิกายน";
  monthThai["12"] = "ธันวาคม";
  const newdate = monthThai[date];
  return newdate;
};

export const changeFormatdateSlip = (date) => {
  let monthThai = [];
  monthThai["01"] = "มกราคม";
  monthThai["02"] = "กุมภาพันธ์";
  monthThai["03"] = "มีนาคม";
  monthThai["04"] = "เมษายน";
  monthThai["05"] = "พฤษภาคม";
  monthThai["06"] = "มิถุนายน";
  monthThai["07"] = "กรกฎาคม";
  monthThai["08"] = "สิงหาคม";
  monthThai["09"] = "กันยายน";
  monthThai["10"] = "ตุลาคม";
  monthThai["11"] = "พฤศจิกายน";
  monthThai["12"] = "ธันวาคม";
  if (date) {
    const newsFormat = moment(moment.utc(date).local().format(), "YYYY-M-DD");
    const newdate =
      moment(newsFormat).format("D") +
      " " +
      monthThai[moment(newsFormat).format("MM")] +
      " " +
      (parseInt(moment(newsFormat).format("YYYY")) + 543).toString();
    return newdate;
  }
};

export const changeOnlyMonth = (date) => {
  let monthThai = [];
  monthThai["01"] = "มกราคม";
  monthThai["02"] = "กุมภาพันธ์";
  monthThai["03"] = "มีนาคม";
  monthThai["04"] = "เมษายน";
  monthThai["05"] = "พฤษภาคม";
  monthThai["06"] = "มิถุนายน";
  monthThai["07"] = "กรกฎาคม";
  monthThai["08"] = "สิงหาคม";
  monthThai["09"] = "กันยายน";
  monthThai["10"] = "ตุลาคม";
  monthThai["11"] = "พฤศจิกายน";
  monthThai["12"] = "ธันวาคม";
  const convertDate = date.slice(0, 10);
  const newdate = monthThai[moment(convertDate).format("MM")];
  return newdate;
};

export const changeFormatdate = (date) => {
  let monthThai = [];
  monthThai["01"] = "มกราคม";
  monthThai["02"] = "กุมภาพันธ์";
  monthThai["03"] = "มีนาคม";
  monthThai["04"] = "เมษายน";
  monthThai["05"] = "พฤษภาคม";
  monthThai["06"] = "มิถุนายน";
  monthThai["07"] = "กรกฎาคม";
  monthThai["08"] = "สิงหาคม";
  monthThai["09"] = "กันยายน";
  monthThai["10"] = "ตุลาคม";
  monthThai["11"] = "พฤศจิกายน";
  monthThai["12"] = "ธันวาคม";
  if (date) {
    // const convertDate = date.slice(0, 10);
    const newdate =
      moment(date).format("D") +
      " " +
      monthThai[moment(date).format("MM")] +
      " " +
      (parseInt(moment(date).format("YYYY")) + 543).toString();
    return newdate;
  }
};

export const changeFormatdateDayMonth = (date) => {
  let monthThai = [];
  monthThai["01"] = "มกราคม";
  monthThai["02"] = "กุมภาพันธ์";
  monthThai["03"] = "มีนาคม";
  monthThai["04"] = "เมษายน";
  monthThai["05"] = "พฤษภาคม";
  monthThai["06"] = "มิถุนายน";
  monthThai["07"] = "กรกฎาคม";
  monthThai["08"] = "สิงหาคม";
  monthThai["09"] = "กันยายน";
  monthThai["10"] = "ตุลาคม";
  monthThai["11"] = "พฤศจิกายน";
  monthThai["12"] = "ธันวาคม";
  if (date) {
    // const convertDate = date.slice(0, 10);
    const newdate =
      moment(date).format("D") + " " + monthThai[moment(date).format("MM")];
    return newdate;
  }
};

export const changeFormatFullDateTime = (date) => {
  let monthThai = [];
  monthThai["01"] = "มกราคม";
  monthThai["02"] = "กุมภาพันธ์";
  monthThai["03"] = "มีนาคม";
  monthThai["04"] = "เมษายน";
  monthThai["05"] = "พฤษภาคม";
  monthThai["06"] = "มิถุนายน";
  monthThai["07"] = "กรกฎาคม";
  monthThai["08"] = "สิงหาคม";
  monthThai["09"] = "กันยายน";
  monthThai["10"] = "ตุลาคม";
  monthThai["11"] = "พฤศจิกายน";
  monthThai["12"] = "ธันวาคม";
  if (date) {
    // const convertDate = date.slice(0, 10);
    const newdate =
      moment(date).format("D") +
      " " +
      monthThai[moment(date).format("MM")] +
      " " +
      (parseInt(moment(date).format("YYYY")) + 543).toString() +
      " " +
      moment(date).format("HH:mm");
    return newdate;
  }
};

export const changeFormatdateThai = (date) => {
  let monthThai = [];
  monthThai["01"] = "มกราคม";
  monthThai["02"] = "กุมภาพันธ์";
  monthThai["03"] = "มีนาคม";
  monthThai["04"] = "เมษายน";
  monthThai["05"] = "พฤษภาคม";
  monthThai["06"] = "มิถุนายน";
  monthThai["07"] = "กรกฎาคม";
  monthThai["08"] = "สิงหาคม";
  monthThai["09"] = "กันยายน";
  monthThai["10"] = "ตุลาคม";
  monthThai["11"] = "พฤศจิกายน";
  monthThai["12"] = "ธันวาคม";
  if (date) {
    // const convertDate = date.slice(0, 10);
    const newdate =
      moment(date).format("D") +
      " " +
      monthThai[moment(date).format("MM")] +
      " " +
      parseInt(moment(date).format("YYYY")).toString();
    return newdate;
  }
};

export const changeFormatMonthYearThai = (date) => {
  let monthThai = [];
  monthThai["01"] = "มกราคม";
  monthThai["02"] = "กุมภาพันธ์";
  monthThai["03"] = "มีนาคม";
  monthThai["04"] = "เมษายน";
  monthThai["05"] = "พฤษภาคม";
  monthThai["06"] = "มิถุนายน";
  monthThai["07"] = "กรกฎาคม";
  monthThai["08"] = "สิงหาคม";
  monthThai["09"] = "กันยายน";
  monthThai["10"] = "ตุลาคม";
  monthThai["11"] = "พฤศจิกายน";
  monthThai["12"] = "ธันวาคม";
  if (date) {
    // const convertDate = date.slice(0, 10);
    const newdate =
      monthThai[moment(date).format("MM")] +
      " " +
      parseInt(moment(date).format("YYYY")).toString();
    return newdate;
  }
};

export const changeYear = (year) => {
  return year + 543;
};

export const pushAge = (date) => {
  const convertDate = moment(
    moment.utc(date).add(-1, "days").local().format(),
    "YYYY-M-DD"
  );
  const presentDate = moment(moment.utc().local().format(), "YYYY-M-DD");

  var visitdate = moment([
    presentDate.year(),
    presentDate.month(),
    presentDate.date(),
  ]);
  var birthyear = moment([
    convertDate.year(),
    convertDate.month(),
    convertDate.date(),
  ]);

  var years = visitdate.diff(birthyear, "year");
  birthyear.add(years, "years");

  return years;
};

export const pushAgeDate = (date, deathDate) => {
  const convertDate = moment(
    moment.utc(date).add(-1, "days").local().format(),
    "YYYY-M-DD"
  );
  const presentDate = moment(
    moment.utc(deathDate).add(-1, "days").local().format(),
    "YYYY-M-DD"
  );

  var visitdate = moment([
    presentDate.year(),
    presentDate.month(),
    presentDate.date(),
  ]);
  var birthyear = moment([
    convertDate.year(),
    convertDate.month(),
    convertDate.date(),
  ]);

  var years = visitdate.diff(birthyear, "year");
  birthyear.add(years, "years");

  return years;
};

export const pushAgeWork = (date) => {
  // const convertDate = moment(date, 'YYYY-M-DD');
  const convertDate = moment(
    moment.utc(date).add(-1, "days").local().format(),
    "YYYY-M-DD"
  );
  const presentDate = moment(moment.utc().local().format(), "YYYY-M-DD");

  var visitdate = moment([
    presentDate.year(),
    presentDate.month(),
    presentDate.date(),
  ]);
  var birthyear = moment([
    convertDate.year(),
    convertDate.month(),
    convertDate.date(),
  ]);

  var years = visitdate.diff(birthyear, "year");
  birthyear.add(years, "years");

  var months = visitdate.diff(birthyear, "M");
  birthyear.add(months, "months");

  var day = visitdate.diff(birthyear, "d");

  return years + " ปี " + months + " เดือน " + day + " วัน";
};

export const pushAgeFullDate = (date) => {
  // const convertDate = moment(date, 'YYYY-M-DD');
  const convertDate = moment(
    moment.utc(date).add(-1, "days").local().format(),
    "YYYY-M-DD"
  );
  const presentDate = moment(moment.utc().local().format(), "YYYY-M-DD");

  var visitdate = moment([
    presentDate.year(),
    presentDate.month(),
    presentDate.date(),
  ]);
  var birthyear = moment([
    convertDate.year(),
    convertDate.month(),
    convertDate.date(),
  ]);

  var years = visitdate.diff(birthyear, "year");
  birthyear.add(years, "years");

  var months = visitdate.diff(birthyear, "M");
  birthyear.add(months, "months");

  var day = visitdate.diff(birthyear, "d");

  return years + ":" + months + ":" + day;
};

export const changeFormatdateStartEnd = (date) => {
  let monthThai = [];
  monthThai["01"] = "มกราคม";
  monthThai["02"] = "กุมภาพันธ์";
  monthThai["03"] = "มีนาคม";
  monthThai["04"] = "เมษายน";
  monthThai["05"] = "พฤษภาคม";
  monthThai["06"] = "มิถุนายน";
  monthThai["07"] = "กรกฎาคม";
  monthThai["08"] = "สิงหาคม";
  monthThai["09"] = "กันยายน";
  monthThai["10"] = "ตุลาคม";
  monthThai["11"] = "พฤศจิกายน";
  monthThai["12"] = "ธันวาคม";
  if (date) {
    // const convertDate = date.slice(0, 10);
    const newdate =
      moment(date).format("DD") + " " + monthThai[moment(date).format("MM")];
    return newdate;
  }
};

export const checkMoreThanLess = (startDate, endDate) => {
  let checkDatemore = moment(startDate, "DD/MM/YYYY")
    .diff(moment(endDate, "DD/MM/YYYY"))
    .toString();

  if (!checkDatemore.includes("-")) {
    return moment(startDate);
  }
};

export const changeFormatFulldate = (date) => {
  let monthThai = [];
  monthThai["01"] = "มกราคม";
  monthThai["02"] = "กุมภาพันธ์";
  monthThai["03"] = "มีนาคม";
  monthThai["04"] = "เมษายน";
  monthThai["05"] = "พฤษภาคม";
  monthThai["06"] = "มิถุนายน";
  monthThai["07"] = "กรกฎาคม";
  monthThai["08"] = "สิงหาคม";
  monthThai["09"] = "กันยายน";
  monthThai["10"] = "ตุลาคม";
  monthThai["11"] = "พฤศจิกายน";
  monthThai["12"] = "ธันวาคม";
  if (date) {
    // const convertDate = date.slice(0, 10);
    const newdate =
      moment(date).format("D") +
      " " +
      monthThai[moment(date).format("MM")] +
      " " +
      (parseInt(moment(date).format("YYYY")) + 543).toString() +
      " " +
      moment(date).format("HH:mm");
    return newdate;
  }
};

export const getTimeFromMins = (mins) => {
  if (mins >= 24 * 60 || mins < 0) {
    throw new RangeError(
      "Valid input should be greater than or equal to 0 and less than 1440."
    );
  }
  var h = (mins / 60) | 0,
    m = mins % 60 | 0;
  if (m == 0) {
    return moment.utc().hours(h).minutes(m).format("h") + " ชั่วโมง";
  } else if (h == 0) {
    return `${h}:${m} ชั่วโมง`;
  } else {
    return moment.utc().hours(h).minutes(m).format("h:m") + " ชั่วโมง";
  }
};

export const dateFormatNumber = (values) => {
  const valueReturn = changeFormatdate(moment(values));
  return valueReturn;
};

export const monthTh = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];

export const disabledDate = (current) => {
  return current && current > moment();
};

export const yearsRangeOfEducation = (range = 100) => {
  const thisYear = Number(moment().add(543, "years").format("YYYY"));
  return { min: thisYear - range, max: thisYear };
};
